<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style=" border-radius: 5px !important;padding-left:0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousFFView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Payment & Debit Note</b-navbar-brand>

          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button
                v-if="ExecutionModel.ccPaymentExpId!=''"
                variant="warning"
                size="sm"
                @click="proceedInv"
              >Proceed To Invoice</b-button>
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <md-layout md-gutter>
              <md-layout md-flex="65"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>Forwarder's Debit Note Receive Date</label>
                </md-layout>

                <md-layout md-flex="100">
                  <date-picker
                  :format="selectDateFormat"
                    lang="en"
                    id="bookingDate"
                    name="bookingDate"
                    v-model="ExecutionModel.forwardingDate"
                  ></date-picker>
                </md-layout>

                <span
                  class="error"
                  v-if="!ExecutionModel.forwardingDate"
                >{{errorExecutionModel.forwardingDate}}</span>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="gutr">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="50">
                <label>
                  TR Submit
                  No.
                </label>
                <b-input
                  name="trSubmitNumber"
                  id="trSubmitNumber"
                  v-model="ExecutionModel.trSubmitNo"
                ></b-input>
                <span
                  class="error"
                  v-if="!ExecutionModel.trSubmitNo"
                >{{errorExecutionModel.trSubmitNo}}</span>
              </md-layout>

              <md-layout md-flex="10"></md-layout>
              <md-layout md-flex="25">
                <label>TR Submit Date</label>

                <date-picker
                :format="selectDateFormat"
                  lang="en"
                  id="trSubmitDate"
                  name="trSubmitDate"
                  v-model="ExecutionModel.trSubmitDate"
                ></date-picker>
                <span
                  class="error"
                  v-if="!ExecutionModel.trSubmitDate"
                >{{errorExecutionModel.trSubmitDate}}</span>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="gutr" style="margin-top:3%">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="50">
                <label>Shipping Payment Detail</label>
                <b-textarea
                  name="shippingDetail"
                  id="shippingDetail"
                  v-model="ExecutionModel.shippingDetail"
                ></b-textarea>
                <span
                  class="error"
                  v-if="!ExecutionModel.shippingDetail"
                >{{errorExecutionModel.shippingDetail}}</span>
              </md-layout>
              <md-layout md-flex="10"></md-layout>

              <md-layout md-flex="25">
                <label>Shipping payment Date</label>

                <date-picker
                :format="selectDateFormat"
                  lang="en"
                  id="shippingDate"
                  name="shippingDate"
                  v-model="ExecutionModel.shippingDate"
                ></date-picker>
                <span
                  class="error"
                  v-if="!ExecutionModel.shippingDate"
                >{{errorExecutionModel.shippingDate}}</span>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="gutr" style="margin-top:3%">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="50">
                <label>Payment sent to Forwarder ­ Details</label>
                <b-textarea
                  name="paymentForwardingDetail"
                  id="paymentForwardingDetail"
                  v-model="ExecutionModel.paymentForwardingDetail"
                ></b-textarea>
                <span
                  class="error"
                  v-if="!ExecutionModel.paymentForwardingDetail"
                >{{errorExecutionModel.paymentForwardingDetail}}</span>
              </md-layout>
              <md-layout md-flex="10"></md-layout>

              <md-layout md-flex="25">
                <label>Payment sent to Forwarder Date</label>

                <md-layout md-flex="100">
                  <date-picker
                  :format="selectDateFormat"
                    lang="en"
                    id="paymentForwardingDate"
                    name="paymentForwardingDate"
                    v-model="ExecutionModel.paymentForwardingDate"
                  ></date-picker>
                </md-layout>

                <span
                  class="error"
                  v-if="!ExecutionModel.paymentForwardingDate"
                >{{errorExecutionModel.paymentForwardingDate}}</span>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="gutr" style="margin-top:3%">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <label>B/L Details</label>
                <b-textarea name="bLDetail" id="bLDetail" v-model="ExecutionModel.bLDetail"></b-textarea>
                <span class="error" v-if="!ExecutionModel.bLDetail">{{errorExecutionModel.bLDetail}}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="20">
                <label>B/L No.(44444444444)</label>

                <b-input v-model="ExecutionModel.bLNum" type="number" @keyup="mblRegexfun"></b-input>
                <span class="error" v-if="!ExecutionModel.bLNum">{{errorExecutionModel.bLNum}}</span>
                <span class="error" v-else-if="mblRegexError!=''">{{mblRegexError}}</span>
              </md-layout>
              <md-layout md-flex="10"></md-layout>

              <md-layout md-flex="25">
                <label>B/L Recevied Date</label>

                <date-picker :format="selectDateFormat" lang="en" id="bLDate" name="bLDate" v-model="ExecutionModel.bLDate"></date-picker>
                <span class="error" v-if="!ExecutionModel.bLDate">{{errorExecutionModel.bLDate}}</span>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="gutr" style="margin-top:3%">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="50">
                <label>Invoice Details for Shipper</label>
                <b-textarea
                  name="invoiceDetail"
                  id="invoiceDetail"
                  v-model="ExecutionModel.invoiceDetail"
                ></b-textarea>
                <span
                  class="error"
                  v-if="!ExecutionModel.invoiceDetail"
                >{{errorExecutionModel.invoiceDetail}}</span>
              </md-layout>
              <md-layout md-flex="10"></md-layout>

              <md-layout md-flex="25">
                <label>Invoice Details Received Date</label>

                <date-picker
                :format="selectDateFormat"
                  lang="en"
                  id="invoiceReceviedDate"
                  name="invoiceReceviedDate"
                  v-model="ExecutionModel.invoiceReceviedDate"
                ></date-picker>
                <span
                  class="error"
                  v-if="!ExecutionModel.invoiceReceviedDate"
                >{{errorExecutionModel.invoiceReceviedDate}}</span>
              </md-layout>
            </md-layout>

            <div class="col-md-7 gutr">
              <b-button
                variant="primary"
                class="pull-right"
                id="addButtonLoaderpro"
                @click="addExecution()"
              >Save</b-button>

              <md-spinner md-indeterminate id="loaderpro" style="display:none"></md-spinner>
            </div>
            <div class="col-md-5">
              <md-spinner md-indeterminate id="loaderpro" style="display:none"></md-spinner>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="alertAddSeaImp"
      @close="onCloseHandover"
    ></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import VueTrix from "vue-trix";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
  beforeMount() {
    if (
      globalPermissionStatus("Custom Clearance") &&
      this.$sessionsStorage.get("editCcImportId") != undefined &&
      this.$sessionsStorage.get("editCcImportId") != "" &&
      this.$sessionsStorage.get("editCcType") != undefined &&
      this.$sessionsStorage.get("editCcType") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/CCImport/CCExportEntry");

      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  watch: {},
  data() {
    return {
      selectDateFormat,
      editorOption: {
        modules: {}
      },
      editorContent: "",
      validate: true,
      isLoading: true,

      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok"
      },

      checkList: [
        {
          value: "Yes"
        },
        {
          value: "No"
        }
      ],
      ExecutionModel: {
        ccPaymentExpId: "",
        ccImportId: this.$sessionsStorage.get("editCcImportId"),
        ccType: "Export",
        forwardingDate: "",
        trSubmitNo: "",
        trSubmitDate: "",
        shippingDetail: "",
        shippingDate: "",
        paymentForwardingDetail: "",
        paymentForwardingDate: "",
        bLDetail: "",
        bLNum: "",
        bLDate: "",
        invoiceDetail: "",
        invoiceReceviedDate: ""
      },
      errorExecutionModel: {
        forwardingDate: "",
        trSubmitNo: "",
        trSubmitDate: "",
        shippingDetail: "",
        shippingDate: "",
        paymentForwardingDetail: "",
        paymentForwardingDate: "",
        bLDetail: "",
        bLNum: "",
        bLDate: "",
        invoiceDetail: "",
        invoiceReceviedDate: ""
      },
      arrayErrorExecutionModel: {
        forwardingDate: "Select Date",
        trSubmitNo: "Enter TR Number",
        trSubmitDate: "Select Date",
        shippingDetail: "Enter Shipping Detail",
        shippingDate: "Select Date",
        paymentForwardingDetail: "Enter Payment Detail",
        paymentForwardingDate: "Select Date",
        bLDetail: "Enter B/L Detail",
        bLNum: "Enter B/L Number",
        bLDate: "Select Date",
        invoiceDetail: "Enter Invoice Detail",
        invoiceReceviedDate: "Select Date"
      },
      mblRegexError: ""
    };
  },

  mounted() {},
  beforeDestroy() {
    // this.$sessionsStorage.set("editExportFCLId", "");
  },
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    VueTrix,
    quillEditor
  },
  computed: {
    clientList() {
      return this.getCLientData;
    }
  },
  methods: {
    proceedInv() {
      this.$router.push({
        path: "/CCImport/CCInvoiceForTallyExport"
      });
    },
    onFileChangeSecondBl() {
      var files = event.target.files || event.dataTransfer.files;

      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
      }
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: this.$sessionsStorage.get("editSeaNormalTrackId")
        }
      };

      axios
        .post(`${URL_BASE}/Api_FFSeaImport/uploadSeaImportDoc.php`, formData, config)
        .then(result => {
          this.ffHouseBL.secondBLupload = result.data;
          // console.log("fdsf", result.data);
        })
        .catch(err => {
          throw err;
        });
    },

    mblRegexfun() {
      var blformat = new RegExp("^[0-9]{11}$");

      if (blformat.test(this.ExecutionModel.bLNum)) {
        this.mblRegexError = "";
      } else {
        this.mblRegexError = "Enter Valid Format";
      }
    },

    validateCheckList(id) {
      let validate_new = true;

      Object.keys(this.errorExecutionModel).map(x => {
        if (this.ExecutionModel[x] == "") {
          validate_new = false;
          this.errorExecutionModel[x] = this.arrayErrorExecutionModel[x];
        } else {
          this.errorExecutionModel[x] = "";
        }
      });

      var blformat = new RegExp("^[0-9]{11}$");

      if (blformat.test(this.ExecutionModel.bLNum)) {
        this.mblRegexError = "";
      } else {
        this.mblRegexError = "Enter Valid Format";
        validate_new = false;
      }

      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    onCloseHandover(type) {
      if (type != "cancel") {
        // this.$router.push({
        //   path: "/CCImport/ccHandoverToRail"
        // });
      }
    },

    addExecution() {
      this.validateCheckList();

      if (this.validate == true) {
        // $("#addButtonLoaderpro").css("display", "none");
        // $("#loaderpro").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Custom/addPaymentExport.php`,
          data: JSON.stringify(this.ExecutionModel),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
              $("#addButtonLoaderpro").css("display", "block");
              $("#loaderpro").css("display", "none");

              if (this.ExecutionModel.ccPaymentExpId != "") {
                this.alert.content = "Data Updated Succesfully";
              } else {
                this.alert.content = "Data Added Succesfully";
              }
              this.$refs["alertAddSeaImp"].open();
              this.getData();
            }
          })
          .catch(error => {});
      }
    },

    getData() {
      this.isLoading = true;

      let array = [];
      let vehicle_drive = {
        itemCode: "itemCode",
        ccImportId: this.$sessionsStorage.get("editCcImportId")
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Custom/fetchExportPayment.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.ccPaymentDetail.length > 0) {
              Object.keys(this.ExecutionModel).map(x => {
                this.ExecutionModel[x] = data.ccPaymentDetail[0][x] || "";
              });
            }

            this.isLoading = false;
          }
        })
        .catch(error => {});
    },
    addNew() {
      this.$router.push({
        path: "/client/addClient"
      });
    },

    previousFFView() {
      window.history.go(-1);
      // this.$router.push({
      //   path: "/CCImport/ediExecution"
      // });
    },
    onFileChangeBoe(id) {
      var files = event.target.files || event.dataTransfer.files;

      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
      }
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: this.$sessionsStorage.get("editSeaNormalTrackId")
        }
      };

      axios
        .post(`${URL_BASE}/Api_FFSeaImport/uploadSeaImportDoc.php`, formData, config)
        .then(result => {
          if (id == "Do") {
            this.ExecutionModel.uploadDo = result.data;
          } else {
            this.ExecutionModel.firstCopyUpload = result.data;
          }
          // console.log("fdsf", result.data);
        })
        .catch(err => {
          throw err;
        });
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// paymentExport.vue?d87e8008